import { Controller } from "@hotwired/stimulus"

// BudgetKpi di pages/ProjectDetail.js:108-152 (31a5bd1): la matita apre il campo con il budget arrotondato
// (String(Math.round(total) || "")), il campo tiene solo le cifre, Invio salva (il form, PUT /app/progetto/:id/budget),
// Esc chiude senza salvare. La risposta (Turbo Stream) porta il toast e il passo 4 riletto.
export default class extends Controller {
  static targets = ["form", "input", "valore"]
  static values = { iniziale: String }

  modifica() {
    this.inputTarget.value = this.inizialeValue
    this.formTarget.hidden = false
    this.valoreTarget.hidden = true
    this.inputTarget.focus()
  }

  chiudi() {
    this.formTarget.hidden = true
    this.valoreTarget.hidden = false
  }

  // e.target.value.replace(/[^0-9]/g, "")
  cifre() {
    const pulito = this.inputTarget.value.replace(/[^0-9]/g, "")
    if (pulito !== this.inputTarget.value) this.inputTarget.value = pulito
  }

  tasto(event) {
    if (event.key === "Escape") this.chiudi()
  }
}
